<template>
  <div class="about">
    <Hero :heading="heading" :paragraph="paragraph"/>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'

export default {
  name: 'About',
  components: {
    Hero
  },
  data() {
    return {
      heading: 'About',
      paragraph: `I'm a software developer with an interest in all aspects of full-stack development.<br><br>If you're interested in working with me, feel free to reach out at <a href="mailto:contact@aidana.dev" class="p-link">contact@aidana.dev</a>`
    }
  }
}
</script>